module.exports = __webpack_public_path__ + "static/media/gssk.3c19175a.png";


//////////////////
// WEBPACK FOOTER
// ./src/gssk.png
// module id = 132
// module chunks = 0